import {createContext} from 'react';

const spinnerContext = createContext();

export default spinnerContext;